import { useState } from 'react'
import { Sparkles, Check } from 'lucide-react'
import {
  AI_CONSENT_TITLE, AI_CONSENT_POINTS, AI_CONSENT_ACCEPT, AI_CONSENT_DECLINE, PRIVACY_POLICY_URL,
} from '@repo/types'
import { api } from '@/lib/api'
import { useAuth } from '@/contexts/AuthContext'

/** Brána pred prvým použitím AI funkcií (asistent, AI popis) — API bez súhlasu vracia 403 AI_CONSENT_REQUIRED. */
export function AiConsentGate({ onDecline, onAccepted }: { onDecline: () => void; onAccepted?: () => void }) {
  const { user, setUser } = useAuth()
  const [saving, setSaving] = useState(false)

  const accept = async () => {
    setSaving(true)
    try {
      const { data } = await api.post('/auth/me/ai-consent')
      if (user) setUser({ ...user, aiConsentAt: data.aiConsentAt })
      onAccepted?.()
    } catch {
      // chybu ukáže interceptor (lib/api.ts)
    } finally {
      setSaving(false)
    }
  }

  return (
    <div className="flex-1 overflow-y-auto p-5 space-y-4">
      <Sparkles className="mx-auto h-8 w-8 text-brand-600 dark:text-brand-400" />
      <h3 className="text-center text-base font-semibold text-gray-900 dark:text-white">{AI_CONSENT_TITLE}</h3>
      <ul className="space-y-3">
        {AI_CONSENT_POINTS.map((p) => (
          <li key={p} className="flex gap-2 text-sm text-gray-600 dark:text-gray-300">
            <Check className="mt-0.5 h-4 w-4 flex-none text-brand-600 dark:text-brand-400" />
            <span>{p}</span>
          </li>
        ))}
      </ul>
      <a href={PRIVACY_POLICY_URL} target="_blank" rel="noopener noreferrer"
        className="block text-center text-sm text-brand-600 dark:text-brand-400 hover:underline">Zásady ochrany osobných údajov</a>
      <button type="button" className="btn btn-primary w-full" disabled={saving} onClick={accept}>{AI_CONSENT_ACCEPT}</button>
      <button type="button" className="btn btn-ghost w-full" onClick={onDecline}>{AI_CONSENT_DECLINE}</button>
    </div>
  )
}
